let status_recibo_prenomina = Object.freeze({
  NUEVO: 1,
  EN_PROCESO: 1,
  PROCESADO: 2,
  CERRADO: 3,
  ERROR: -1,
});

module.exports = { status_recibo_prenomina };
